import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";

interface Props {
  rows: {
    label: string;
    labelTooltip?: string;
    value: string;
    valueDetails?: string;
  }[];
}

export const TooltipTable = ({ rows }: Props) => {
  return (
    <div className="border border-v2-tertiary rounded bg-v2-primary text-xs">
      <table className="w-full">
        <tbody>
          {rows.map((row, index) => {
            return (
              <tr
                key={row.label}
                className={clsx("h-8 text-xs", {
                  "border-b border-v2-tertiary": index < rows.length - 1,
                })}
              >
                <td className="px-4 border-r border-v2-tertiary w-1/2">
                  {row.label}
                  {row.labelTooltip && (
                    <GenericTooltip
                      content={row.labelTooltip}
                      placement="top"
                      overlayClassName="max-w-[350px]"
                    />
                  )}
                </td>
                <td className="px-4">
                  <div className="flex items-center justify-end gap-2 ">
                    {row.valueDetails && (
                      <div
                        className={clsx(
                          "font-mono text-xs rounded h-5 flex items-center px-1.5 text-nowrap",
                          "text-v2-action-positive-hover bg-v2-alien/400/10%",
                        )}
                      >
                        {row.valueDetails}
                      </div>
                    )}
                    {row.value}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
